module.exports = __webpack_public_path__ + "img/icon-3.5c8f9d68.png";